import { render, staticRenderFns } from "./ComponentOverview.vue?vue&type=template&id=0d01b1a8&"
import script from "./ComponentOverview.vue?vue&type=script&lang=js&"
export * from "./ComponentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports